var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandAllBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.702,
    height: 20.702,
    viewBox: "0 0 20.702 20.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30674",
    "data-name": "Group 30674",
    transform: "translate(-78.149 -2357.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16647",
    "data-name": "Path 16647",
    d: "M23.7,12.2V3H14.5l3.784,3.784-11.5,11.5L3,14.5v9.2h9.2L8.417,19.918l11.5-11.5Z",
    transform: "translate(75.149 2354.779)",
    fill: "#203864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17632",
    "data-name": "Path 17632",
    d: "M23.7,12.2V3H14.5l3.784,3.784-11.5,11.5L3,14.5v9.2h9.2L8.417,19.918l11.5-11.5Z",
    transform: "translate(101.852 2354.779) rotate(90)",
    fill: "#203864"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAllBlueIcon);
export default __webpack_public_path__ + "static/media/expandAll-blueIcon.fbf64bffd691e066d15f8cf31c35c4a5.svg";
export { ForwardRef as ReactComponent };